import { Close, Menu, Search } from '@mui/icons-material';
import { IconButton, Container as MuiContainer, styled } from '@mui/material';
import { useState } from 'react';
import { CookieConsent } from '#components/CookieConsent/index.tsx';
import { MenuDrawer } from '#components/MenuDrawer/index.tsx';
import { ToolbarState } from '#enums/headerStates.ts';
import { tt } from '#i18n/index.ts';
import { DollygripLogo } from '../DollygripLogo/index.tsx';

const Container = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    height: '64px',
  },
  height: '56px',
  justifyContent: 'space-between',
  width: '100%',
}));

const LeftContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-start',
});

export type Props = {
  activeToolbarState?: ToolbarState;
  searchFullScreen?: boolean;
  setActiveToolbarState: (state: ToolbarState | undefined) => void;
  setSearchFullScreen: (fullScreen: boolean) => void;
};

export const DefaultBar = ({
  activeToolbarState,
  searchFullScreen,
  setActiveToolbarState,
  setSearchFullScreen,
}: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <MuiContainer disableGutters maxWidth="xl">
        <Container>
          <LeftContainer sx={{ marginLeft: theme => `-${theme.spacing(1)}` }}>
            <IconButton
              aria-label={tt('header.mainMenuAriaLabel')}
              color="inherit"
              edge="end"
              onClick={() => {
                setMenuOpen(true);
              }}
            >
              <Menu />
            </IconButton>
            <DollygripLogo sx={{ marginLeft: theme => theme.spacing(3) }} />
          </LeftContainer>
          {activeToolbarState === ToolbarState.Search ? (
            <IconButton
              aria-label={tt('header.closeSearchAriaLabel')}
              color="inherit"
              edge="end"
              onClick={() => {
                setActiveToolbarState(undefined);

                if (searchFullScreen) {
                  setSearchFullScreen(false);
                }
              }}
            >
              <Close />
            </IconButton>
          ) : (
            <IconButton
              aria-label={tt('header.openSearchAriaLabel')}
              color="inherit"
              edge="end"
              onClick={() => {
                setActiveToolbarState(ToolbarState.Search);
              }}
            >
              <Search />
            </IconButton>
          )}
        </Container>
      </MuiContainer>
      <MenuDrawer open={menuOpen} setOpen={setMenuOpen} />
      <CookieConsent />
    </>
  );
};
